import useToaster from "./useToaster";

export default function useTrendScout() {
  const { addToaster } = useToaster();
  const baseUrl = process.env.REACT_APP_API_URL || "";
  const url = `${baseUrl}/api/trendscout`;

  const safeFetch = async (path, options = {}) => {
    try {
      const token = localStorage.getItem("x-token");
      const headers = { Authorization: `Bearer ${token}` };
      if (!(options.body instanceof FormData))
        headers["Content-Type"] = "application/json";
      if (options.headers) Object.assign(headers, options.headers);

      const r = await fetch(`${url}${path}`, { ...options, headers });
      if (r.status === 401) localStorage.removeItem("x-token");
      return await r.json();
    } catch (e) {
      addToaster({ message: e.message, severity: "error" });
      throw e;
    }
  };

  return {
    listItems: ({
      page = 1,
      pageSize = 50,
      search = "",
      countries = [],
      topics = [],
      sort = "hot",
      status = "",
    } = {}) => {
      const qs = new URLSearchParams({ page, pageSize, sort });
      if (status) qs.set("status", status);
      if (search) qs.set("search", search);
      if (countries.length) qs.set("countries", countries.join(","));
      if (topics.length) qs.set("topics", topics.join(","));
      return safeFetch(`/items?${qs}`);
    },
    getConfig: () => safeFetch(`/config`),
    saveConfig: (selectedCountries, selectedTopics) =>
      safeFetch(`/config`, {
        method: "POST",
        body: JSON.stringify({ selectedCountries, selectedTopics }),
      }),
    getStatus: () => safeFetch(`/status`),
    triggerRefresh: () => safeFetch(`/refresh`, { method: "POST" }),
    generate: (guid) =>
      safeFetch(`/generate`, {
        method: "POST",
        body: JSON.stringify({ guid }),
      }),
  };
}
